import { create } from 'zustand';
const useViewerOutput = create(() => ({
    ready: false,
    isVideoStreaming: false,
    audioMuted: true,
    watchingStartedAt: undefined,
    lastReceivedFrameAt: undefined,
}));
const reactiveOutput = {
    useReady: () => {
        return useViewerOutput((s) => s.ready);
    },
    useIsVideoStreaming: () => {
        return useViewerOutput((s) => s.isVideoStreaming);
    },
    useAudioMuted: () => {
        return useViewerOutput((s) => s.audioMuted);
    },
    useWatchingStartedAt: () => {
        return useViewerOutput((s) => s.watchingStartedAt);
    },
    useLastReceivedFrameAt: () => {
        return useViewerOutput((s) => s.lastReceivedFrameAt);
    },
};
export class ViewerServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setReady(ready) {
        useViewerOutput.setState({ ready });
    }
    setIsVideoStreaming(isVideoStreaming) {
        useViewerOutput.setState({ isVideoStreaming });
    }
    setAudioMuted(audioMuted) {
        useViewerOutput.setState({ audioMuted });
    }
    getAudioMuted() {
        return useViewerOutput.getState().audioMuted;
    }
    setWatchingStartedAt(watchingStartedAt) {
        useViewerOutput.setState({ watchingStartedAt });
    }
    getWatchingStartedAt() {
        return useViewerOutput.getState().watchingStartedAt;
    }
    setLastReceivedFrameAt(lastReceivedFrameAt) {
        useViewerOutput.setState({ lastReceivedFrameAt });
    }
}
